export const parentDashboardAr = {
  // Sections
  home: 'الرئيسية',
  myGrades: 'درجاتي',
  quranProgress: 'متابعة القرآن',
  myMessages: 'رسائلي',
  logout: 'خروج',
  
  // Welcome
  welcome: 'مرحباً',
  parentOf: 'ولي أمر:',
  noLinkedStudents: 'لا يوجد طلاب مرتبطين',
  
  // Stats
  averageHifz: 'متوسط الحفظ',
  noSessionsToday: 'لا توجد جلسة',
  averageGrades: 'متوسط الدرجات',
  subjectsCount: 'عدد المواد',
  receivedMessages: 'الرسائل المستلمة',
  sentMessages: 'الرسائل المرسلة',
  noReceivedMessages: 'لا توجد رسائل مستلمة',
  noSentMessages: 'لا توجد رسائل مرسلة',
  hizbUnit: 'حزب',
  
  // Messages
  recentMessages: 'آخر الرسائل',
  noMessages: 'لا توجد رسائل',
  from: 'من:',
  to: 'إلى:',
  refresh: 'تحديث',
  sendMessage: 'إرسال رسالة',
  selectStudent: 'اختر الطالب',
  selectRecipient: 'اختر المستلم',
  recipientTeacher: 'الأستاذ',
  recipientAdmin: 'المدير',
  administration: 'الإدارة',
  teachers: 'الأساتذة',
  messageSubject: 'موضوع الرسالة',
  messagePlaceholder: 'اكتب رسالتك هنا...',
  sendButton: 'إرسال',
  messageSent: 'تم إرسال الرسالة بنجاح',
  messageError: 'خطأ في إرسال الرسالة',
  
  // Message priorities
  priorityNormal: 'عادية',
  priorityHigh: 'عالية',
  priorityUrgent: 'عاجلة',
  
  // Report types
  reportTypeAssignment: 'واجب منزلي',
  reportTypeProgress: 'تقرير تقدم',
  reportTypeAchievement: 'إنجاز متميز',
  reportTypeConcern: 'ملاحظة مهمة',
  
  // Quran progress
  lastSession: 'آخر جلسة',
  newMemorization: 'الحفظ الجديد',
  review: 'المراجعة',
  assignmentForNextSession: 'الواجب للجلسة القادمة',
  note: 'الملاحظة',
  hizbMemorized: 'حزب محفوظ',
  progressLevel: 'تقدم الحفظ',
  percentageOfQuran: 'من القرآن',
  
  // Progress levels
  beginner: 'مبتدئ',
  intermediate: 'متوسط',
  advanced: 'متقدم',
  veryAdvanced: 'متقدم جداً',
  
  // Grades
  linkedStudentsGrades: 'درجات الطلاب المرتبطين',
  student: 'الطالب',
  studentLabel: 'الطالب/ـة',
  subject: 'المادة',
  grade: 'الدرجة',
  date: 'التاريخ',
  comment: 'التعليق',
  noGrades: 'لا توجد درجات متاحة',
  
  // Common
  update: 'تحديث',
  loading: 'جاري التحميل...',
  error: 'خطأ',
  retry: 'إعادة المحاولة',
  dateUnknown: '',
  cancel: 'إلغاء',
  optional: 'اختياري',
  
  // Message
  message: 'الرسالة',
  
  // Send message form
  selectAdminOrTeachers: 'يرجى اختيار الإدارة أو الأساتذة أو كلاهما',
  selectStudentForTeachers: 'يرجى اختيار الطالب لإرسال الرسالة إلى الأساتذة',
  noTeachersForStudent: 'لا يوجد أساتذة مرتبطين بهذا الطالب. يرجى التواصل مع الإدارة.',
  messageWillBeSentToAdmins: 'سيتم إرسال الرسالة إلى جميع المديرين',
  messageWillBeSentToAdminsOnly: 'سيتم إرسال الرسالة إلى جميع المديرين فقط',
  messageWillBeSentToAdminsAndTeachers: 'سيتم إرسال الرسالة إلى جميع المديرين وأساتذة الطالب المحدد',
  messageWillBeSentToTeachersOnly: 'سيتم إرسال الرسالة إلى أساتذة الطالب المحدد فقط',
  selectStudentForTeachersMessage: 'يرجى اختيار طالب لإرسال الرسالة إلى أساتذته',
  messageWillBeSentToAdminsSelectStudent: 'سيتم إرسال الرسالة إلى جميع المديرين. يرجى اختيار طالب لإرسال الرسالة إلى أساتذته.',
  
  // Password change
  changePassword: 'تغيير كلمة المرور',
  oldPassword: 'كلمة المرور القديمة',
  newPassword: 'كلمة المرور الجديدة',
  confirmPassword: 'تأكيد كلمة المرور',
  enterOldPassword: 'أدخل كلمة المرور القديمة',
  enterNewPassword: 'أدخل كلمة المرور الجديدة',
  confirmNewPassword: 'أكد كلمة المرور الجديدة',
  passwordChangedSuccess: 'تم تغيير كلمة المرور بنجاح',
  errorChangingPassword: 'خطأ في تغيير كلمة المرور',
  passwordTooShort: 'كلمة المرور يجب أن تكون على الأقل 6 أحرف',
  passwordMismatch: 'كلمات المرور غير متطابقة',
  fillAllFields: 'يرجى ملء جميع الحقول',
  changing: 'جاري التغيير...',

  // Branding & sender types
  associationName: 'جمعية الفلاح',
  parentBoardSubtitle: 'لوحة ولي الأمر',
  senderTeacher: 'الأستاذ',
  senderAdmin: 'المدير',
  senderParent: 'ولي الأمر',
  notSpecified: 'غير محدد',
};

